import $ from 'jquery';

const common = () => {
  $('.o-link-back').on('click', e => {
    e.preventDefault();
    window.history.back();
  });
};
export default common;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/ct-cubed-chisel/src/scripts/modules/common.js